import { forwardRef } from "react";
import { IMaskInput } from 'react-imask';

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask={props.mask}
            definitions={{
                '9': /[0-9]/,
                'A': /[a-zA-Z]/,
                '#': /[0-9a-zA-Z]/
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

export default TextMaskCustom;

